import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { UPDATE_PLC_SAFETY_EVENT } from './actionTypes';
import { updatePlcSafetyEventSuccessful, updatePlcSafetyEventFailed } from './actions';
import { getPlcSafetyAPI } from '../../../api/plcSafety';

const plcSafetyAPI = getPlcSafetyAPI();

function* updateEvent({ payload: { event } }) {
  try {
    const response = yield call(plcSafetyAPI.updateEvent, event.token, event.id, event);
    if (response.message) {
      yield put(updatePlcSafetyEventSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(updatePlcSafetyEventFailed(error));
  }
}

export function* watchUpdatePlcSafetyEvent() {
  yield takeEvery(UPDATE_PLC_SAFETY_EVENT, updateEvent);
}

function* updatePlcSafetyEventSaga() {
  yield all([fork(watchUpdatePlcSafetyEvent)]);
}

export default updatePlcSafetyEventSaga;
